export default "__VITE_ASSET__DYOrVWi2__"